import { useSaveScripts } from '@/features/_data/useScripts';
import { TOASTTYPE, useToast } from '@/ui/Toast/Toast';
import { fetcher } from '@/utils/fetcher';
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { RETAIL_API_URL } from 'src/utils/envConfig';

type UseHandleSaveScriptProps = {
  unitId: string;
  code: string;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
};
const useHandleSaveScript = ({
  unitId,
  code,
  setIsDirty,
}: UseHandleSaveScriptProps) => {
  const toast = useToast();
  const intl = useIntl();
  const { saveScript, isLoading: savingScript } = useSaveScripts(unitId ?? '');
  const [isSavingStatus, setIsSavingStatus] = useState(false);
  const handleSaveScript = useCallback(async () => {
    // save the script
    if (code) {
      await saveScript(code);
    }

    setIsDirty(false);

    // disable logic editor in unit settings
    try {
      setIsSavingStatus(true);
      await fetcher(`${RETAIL_API_URL}/units/disableLogicEditor`, {
        method: 'PUT',
        body: JSON.stringify({ unitId }),
      });
      setIsSavingStatus(false);
    } catch (error) {
      toast({
        title: intl.formatMessage({
          defaultMessage:
            'Error! Something went wrong disabling the Logic Editor.',
          id: 'hCYjQy',
        }),
        mode: TOASTTYPE.Danger,
      });
      console.error('Error updating Logic Editor status:', error);
    }
  }, [saveScript, unitId, code]);

  return { handleSaveScript, isLoading: savingScript || isSavingStatus };
};

export default useHandleSaveScript;
